// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addNewItemsStyles } from "@west/App/Components/MyListsDetails/AddNewItems";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

addNewItemsStyles.container = {
    css: css`
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

addNewItemsStyles.orderUploadGridItem = {
    width: [12, 12, 6, 6, 6],
};

addNewItemsStyles.uploadInstructionsGridItem = {
    width: [12, 12, 6, 6, 6],
};

addNewItemsStyles.actionButton = {
    variant: "tertiary",
    css: css`
        word-wrap: nowrap;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

addNewItemsStyles.productSelectorModal = {
    sizeVariant: "medium",
};

addNewItemsStyles.actionsWrapper = {
    css: css`
        display: flex;
        margin-top: 20px;
        justify-content: end;
        gap: 15px;
    `,
};

addNewItemsStyles.productSelectorStyles = {
    searchGridItem: {
        css: css`
            &&& {
                flex: 1;
                max-width: 450px;
                min-width: 200px;
                position: relative;
            }
        `,
    },
};
